export enum RecurringInvoiceEditorAction {
  SaveRecurringInvoiceDraft = 'saveRecurringInvoiceDraft',
  SaveAndActivateRecurringInvoice = 'saveAndActivateRecurringInvoice',
}
